import {Component, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";

@Component({
    selector: 'app-plan-your-events',
    templateUrl: './plan-your-events.component.html'
})
export class PlanYourEventsComponent implements OnInit {

    public slug;
    public page = {
        title: '',
        slug: '',
        cover_image: '',
        banner_text: '',
        content: ''
    };

    tour_operators = [];

    suppliers = [];

    supplier_types = [];
    allSupplierTypes: Array<any>;
    partOfSupplierTypes: Array<any>;
    supplierTypesHasmore: boolean;
    supplierTypesCollapsed: boolean;

    selected_supplier_types = '';
    selected_activity_types = '';

    activity_types = [
        {'id': 'activities_tours', 'name': 'Activities and tours'},
        {'id': 'airlines', 'name': 'Airlines'},
        {'id': 'airport_services', 'name': 'Airport services'},
        {'id': 'bicycle_rental', 'name': 'Bicycle rental'},
        {'id': 'boat_cruise', 'name': 'Boat and cruise'},
        {'id': 'bus_car_rental', 'name': 'Bus & Car rental'},
        {'id': 'helicopter_hire', 'name': 'Helicopter hire'},
        {'id': 'limousine_rental', 'name': 'Limousine rental'},
        {'id': 'motorbike_rental', 'name': 'Motorbike rental'},
        {'id': 'public_transportation', 'name': 'Public transportation'},
        {'id': 'railroad', 'name': 'Railroad'}
    ];

    operator_types = {};


    constructor(private route: ActivatedRoute, private http: HttpClient, public _auth: AuthService) {
        this.allSupplierTypes = [];
        this.partOfSupplierTypes = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params.slug) {
                this.slug = params['slug'];
                this.http.get(Conf.API_URL + '/supplier-type/?slug=' + this.slug).subscribe(
                    data => {
                        if (data['results'].length) {
                            this.selected_supplier_types = data['results'][0]['id'];
                        }
                        this.getSuppliers();
                    },
                    error => {
                        console.log(error.error)
                    }
                );
                this.getTourOperators();
            }

            this.getPage();
            this.getSupplierTypes();
            this.getTourOperatorTypes();
        });
    }

    getPage() {
        this.http.get(Conf.API_URL + '/bar/?slug=plan-your-event').subscribe(
            data => {
                if (data['results'].length) {
                    this.page = data['results'][0];
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getSupplierTypes() {
        this.http.get(Conf.API_URL + '/supplier-type/?show_all&count=0').subscribe(
            data => {
                this.allSupplierTypes = data['results'];
                this.supplierTypesHasmore = this.allSupplierTypes.length > 10;
                this.supplierTypesCollapsed = this.allSupplierTypes.length > 10;
                this.partOfSupplierTypes = JSON.parse(JSON.stringify(this.allSupplierTypes)).slice(0, 10);
                this.supplier_types = this.partOfSupplierTypes;
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getTourOperatorTypes() {
        this.http.get(Conf.API_URL + '/get-tour-types/').subscribe(
            data => {
                this.operator_types = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getTourOperators() {
        this.http.get(Conf.API_URL + '/tour-operators/?show_all&type=' + this.selected_activity_types).subscribe(
            data => {
                this.tour_operators = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseSupplier() {
        this.selected_supplier_types = $('input[name="supplier_type"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        if (this.selected_supplier_types) {
            this.getSuppliers();
        } else {
            this.suppliers = [];
        }
    }

    getSuppliers() {
        this.http.get(Conf.API_URL + '/supplier/?show_all&type=' + this.selected_supplier_types).subscribe(
            data => {
                this.suppliers = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    choseActivityType() {
        this.selected_activity_types = $('input[name="activity_type"]:checked').map(function () {
            return $(this).val();
        }).get().join(',');
        if (this.selected_activity_types) {
            this.getTourOperators();
        } else {
            this.tour_operators = [];
        }
    }

    splitData(html) {
        return html.split(/\n/);
    }

    showMore(type: string): void {
        switch (type) {
            case 'suppliers': {
                this.supplier_types = this.supplierTypesCollapsed ? this.allSupplierTypes : this.partOfSupplierTypes;
                this.supplierTypesCollapsed = !this.supplierTypesCollapsed;
            }
        }
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/plan-your-events/plan-your-events.component.ts